import * as Sentry from '@sentry/react';
import {Link, useRouteError} from 'react-router-dom';
import PropTypes from 'prop-types';
import Header from './components/Header/Header';
import {useEffect} from 'react';

// Función para determinar el tipo de error
const getErrorType = (error) => {
  if (!error) return 'permission';
  if (error.status === 403) return 'permission';
  if (error.status === 404) return 'notFound';
  return 'generic';
};

// Configuración de mensajes personalizados
const errorMessages = {
  permission: {
    title: "Oops!",
    message: "No tienes permiso para ver esta pantalla"
  },
  notFound: {
    title: "Página no encontrada",
    message: "La página que buscas no existe"
  },
  generic: {
    title: "Oops!",
    message: "Ocurrió un error inesperado"
  }
};

export default function ErrorPage({goBackUrl}) {
  const error = useRouteError();

  console.log("ErrorPage error:", error);

  useEffect(() => {
    // Solo enviar a Sentry si hay un error real (no errores de permisos)
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  // Determinar el tipo de error y obtener el mensaje correspondiente
  const errorType = getErrorType(error);
  const errorConfig = errorMessages[errorType];

  return (
    <div id="error-page">
      {!goBackUrl && <Header />}
      <div className="container mt-4">
        <h1>{errorConfig.title}</h1>
        <p>{errorConfig.message}</p>
        {/* Mostrar detalles técnicos solo para errores genéricos */}
        {errorType === 'generic' && error && (
          <p><i>{error.statusText || error.message}</i></p>
        )}
        {goBackUrl ? (
          <Link to={goBackUrl}>Volver al inicio</Link>
        ) : (
          <button className="btn btn-warning" onClick={() => history.back()}>
            Volver
          </button>
        )}
      </div>
    </div>
  );
}

ErrorPage.propTypes = {
  goBackUrl: PropTypes.string,
};
